import React from 'react';

const Header = () => {
  return (
    <header className="flex flex-col justify-center px-10 py-4 w-full bg-white max-md:px-5 max-md:max-w-full">
      <div className="flex flex-wrap gap-10 justify-between items-center w-full max-md:max-w-full">
        <div className="flex gap-3 justify-center items-center self-stretch my-auto text-2xl font-bold text-black min-w-60">
          <img
            src="https://cdn.acsdev.in/Rentastic/rentastic.png"
            alt="Rentastic Toys Logo"
            className="object-contain shrink-0 self-stretch my-auto bg-blend-normal aspect-square w-[52px]"
          />
          <div className="self-stretch my-auto">
            rentastic toys
          </div>
        </div>
        <div className="self-stretch my-auto text-sm font-medium rounded-none min-w-60 text-neutral-600 w-[525px] max-md:max-w-full">
          <div className="flex flex-col justify-center items-start px-5 py-3 border border-solid bg-neutral-50 border-black border-opacity-10 rounded-[90px] max-md:max-w-full">
            <div>Find for product</div>
          </div>
        </div>
        <div className="flex gap-3.5 items-start self-stretch my-auto min-w-60">
          <div className="flex gap-5 items-start min-w-60">
            <div className="text-xs font-bold text-gray-800 whitespace-nowrap w-[43px]">
              <div className="flex flex-col items-center px-1 pt-1.5 pb-5 bg-white rounded-full fill-white h-[43px] w-[43px]">
                <div className="flex flex-col justify-center items-center px-1 w-4 h-4 bg-yellow-400 rounded-full">
                  <div>2</div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start text-black w-[181px]">
              <div className="flex gap-3.5 items-center">
                <img
                  src="https://cdn.acsdev.in/Rentastic/5.png"
                  alt="User Avatar"
                  className="object-contain shrink-0 self-stretch my-auto w-10 rounded-full aspect-square"
                />
                <div className="flex flex-col self-stretch my-auto rounded-none w-[99px]">
                  <div className="self-start text-xs text-center">
                    Good Morning,
                  </div>
                  <div className="text-sm font-semibold">
                    michelle yeoh
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
